import { ElementType } from "react"
import * as T from "trunx"
import cn from "classnames"
import type { PolymorphicPropsWithoutRef } from "react-polymorphic-types"

import style from "./style.module.scss"

const defaultElement = T.Button

interface OwnProps extends T.ButtonProps {
    isLikeLink?: boolean
    isInlineLink?: boolean
    hasSmallGaps?: boolean
    isResponsive?: boolean
    secondary?: boolean
}

export type Props<T extends ElementType = typeof defaultElement> = PolymorphicPropsWithoutRef<
    OwnProps,
    T
>

export function Button<T extends ElementType = typeof defaultElement>({
    as,
    className,
    isLikeLink,
    isInlineLink,
    hasSmallGaps,
    isResponsive,
    secondary,
    ...props
}: Props<T>) {
    const Element: ElementType = as || defaultElement
    return (
        <Element
            {...props}
            className={cn(className, "blm-button", {
                "is-like-link": isLikeLink,
                "is-inline-link": isInlineLink,
                "has-small-gaps": hasSmallGaps,
                "button-secondary": secondary,
                [style.isResponsive]: isResponsive,
            })}
        />
    )
}
